import { type ExtensionParams, type Parameters } from '@atlaskit/editor-common/extensions';

/**
 * Determines if the extension should be displayed as inline based on the extension parameters.
 * @param extensionParams - The extension parameters.
 * @returns True if the extension should be displayed as inline, false otherwise.
 */
export function shouldDisplayExtensionAsInline<T extends Parameters = Parameters>(
	extensionParams: ExtensionParams<T>,
): boolean {
	const macroParams = extensionParams.parameters?.macroParams;
	// This logic is for third party macro Scroll Versions
	// At first, the ADF is using atlassian-macro-output-type
	// However, from some point, the ADF changed to use alignment instead
	// This is why we need to check both
	const displayAsInline =
		macroParams?.['atlassian-macro-output-type']?.value === 'INLINE' ||
		macroParams?.alignment?.value === 'BEFOREANDAFTER';
	return Boolean(extensionParams.type === 'bodiedExtension' && displayAsInline);
}
